import React, { useState, useEffect, useContext } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import useImage from 'use-image';
import hycapsInjectionUnit from '../../../assets/HyCAPInjectionUnit.svg';
import FeedThroat from '../../../assets/FeedThroat.svg';
import ExtruderBarrel from '../../../assets/ExtruderBarrel.svg';
import Screw from '../../../assets/Screw.svg';
import ShutoffNozzle from '../../../assets/ShutoffNozzle.svg';
import Nozzle from '../../../assets/Nozzle.svg';
import InjectionPiston from '../../../assets/InjectionPiston.svg';
import RadialMotor from '../../../assets/RadialMotor.svg';
import InjectionCylinder from '../../../assets/InjectionCylinder.svg';
import { KonvaEventObject } from 'konva/lib/Node';
import { MachineCanvasProps } from '../../../../InjectionCycle/components/interfaces';
import { useNavigate } from 'react-router-dom';
import { findSubAssetsAvailable } from '../../../../utils/helper';
import { AppContext } from '../../../../../../App';

const InjectionUnitCanvas: React.FC<MachineCanvasProps> = ({ hoveredPart, setHoveredPart, machineName, navigationState }) => {
    const navigate = useNavigate();
    const appContextProps: any = useContext(AppContext)
    const [stageSize, setStageSize] = useState({ width: window.innerWidth, height: 550 });

    const [hycapsInjectionUnitImg] = useImage(hycapsInjectionUnit);
    const [FeedThroatimg] = useImage(FeedThroat);
    const [ExtruderBarrelImg] = useImage(ExtruderBarrel);
    const [ScrewImg] = useImage(Screw);
    const [ShutoffNozzleImg] = useImage(ShutoffNozzle);
    const [NozzleImg] = useImage(Nozzle);
    const [InjectionPistonImg] = useImage(InjectionPiston);
    const [RadialMotorImg] = useImage(RadialMotor);
    const [InjectionCylinderImg] = useImage(InjectionCylinder);

    const handleMouseMove = (e: KonvaEventObject<MouseEvent>) => {
        const { x, y } = e.target.getStage()?.getPointerPosition() || { x: 0, y: 0 };

        if (x >= stageSize.width * 0.428 && x <= stageSize.width * 0.5 && y >= stageSize.height * 0.1 && y <= stageSize.height * 0.45 && navigationState[("Feed Throat").toLowerCase()]) {
            setHoveredPart('Feed Throat');
        } else if ((((x >= stageSize.width * 0.233 && x <= stageSize.width * 0.315) || (x >= stageSize.width * 0.37 && x <= stageSize.width * 0.5)) && y >= stageSize.height * 0.43 && y <= stageSize.height * 0.48) && navigationState[("Screw").toLowerCase()]) {
            setHoveredPart('Screw');
        } else if ((x >= stageSize.width * 0.23 && x <= stageSize.width * 0.42) && ((y >= stageSize.height * 0.38 && y <= stageSize.height * 0.43) || (y >= stageSize.height * 0.38 && y <= stageSize.height * 0.6)) && navigationState[("Extruder Barrel").toLowerCase()]) {
            setHoveredPart('Extruder Barrel');
        } else if (x >= stageSize.width * 0.185 && x <= stageSize.width * 0.205 && y >= stageSize.height * 0.42 && y <= stageSize.height * 0.49 && navigationState[("Shut Off Nozzle").toLowerCase()]) {
            setHoveredPart('Shut Off Nozzle');
        } else if (x >= stageSize.width * 0.165 && x <= stageSize.width * 0.225 && y >= stageSize.height * 0.44 && y <= stageSize.height * 0.47 && navigationState[("Nozzle Tip").toLowerCase()]) {
            setHoveredPart('Nozzle Tip');
        } else if (((x >= stageSize.width * 0.515 && x <= stageSize.width * 0.57 && y >= stageSize.height * 0.38 && y <= stageSize.height * 0.53) || (x >= stageSize.width * 0.57 && x <= stageSize.width * 0.605 && y >= stageSize.height * 0.43 && y <= stageSize.height * 0.48)) && navigationState[("Injection Piston").toLowerCase()]) {
            setHoveredPart('Injection Piston');
        } else if ((x >= stageSize.width * 0.6776 && x <= stageSize.width * 0.7 && y >= stageSize.height * 0.42 && y <= stageSize.height * 0.5) && navigationState[("Radial Motor").toLowerCase()]) {
            setHoveredPart('Radial Motor');
        } else if (((x >= stageSize.width * 0.605 && x <= stageSize.width * 0.615 && y >= stageSize.height * 0.43 && y <= stageSize.height * 0.48) || (x >= stageSize.width * 0.615 && x <= stageSize.width * 0.665 && y >= stageSize.height * 0.4 && y <= stageSize.height * 0.51)) && navigationState[("Injection Cylinder").toLowerCase()]) {
            setHoveredPart('Injection Cylinder');
        } else {
            setHoveredPart('');
        }
    };

    useEffect(() => {
           const handleResize = () => {
             setStageSize({
               width: window.innerWidth - (appContextProps.sideBarOpenStatus ? 260 : 10),
               height: 550,
             });
           };
        handleResize(); // Call handleResize immediately to set the initial size
           window.addEventListener('resize', handleResize);
           return () => window.removeEventListener('resize', handleResize);
         }, [appContextProps.sideBarOpenStatus]);

    return (
        <Stage width={stageSize.width} height={stageSize.height} onMouseMove={handleMouseMove}>
            <Layer>
                <Image
                    image={hycapsInjectionUnitImg}
                    x={stageSize.width * 0.04}
                    y={stageSize.height * 0}
                    width={stageSize.width * 0.8}
                    height={stageSize.height * 1.0}
                />
                {hoveredPart === 'Feed Throat' && (
                    <Image
                        image={FeedThroatimg}
                        x={stageSize.width * 0.428}
                        y={stageSize.height * 0.03}
                        width={stageSize.width * 0.099}
                        height={stageSize.height * 0.42}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Feed%20Throat/reportview`,{ state: navigationState[('Feed Throat').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Extruder Barrel' && (
                    <Image
                        image={ExtruderBarrelImg}
                        x={stageSize.width * 0.233}
                        y={stageSize.height * 0.335}
                        width={stageSize.width * 0.19}
                        height={stageSize.height * 0.19}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Extruder%20Barrel/reportview`,{ state: navigationState[('Extruder Barrel').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Screw' && (
                    <Image
                        image={ScrewImg}
                        x={stageSize.width * 0.233}
                        y={stageSize.height * 0.367}
                        width={stageSize.width * 0.28}
                        height={stageSize.height * 0.11}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Screw/reportview`,{ state: navigationState[('Screw').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Shut Off Nozzle' && (
                    <Image
                        image={ShutoffNozzleImg}
                        x={stageSize.width * 0.1539}
                        y={stageSize.height * 0.345}
                        width={stageSize.width * 0.06}
                        height={stageSize.height * 0.15}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Shut%20Off%20Nozzle/reportview`,{ state: navigationState[('Shut Off Nozzle').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Nozzle Tip' && (
                    <Image
                        image={NozzleImg}
                        x={stageSize.width * 0.132}
                        y={stageSize.height * 0.44}
                        width={stageSize.width * 0.09}
                        height={stageSize.height * 0.05}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Nozzle%20Tip/reportview`,{ state: navigationState[('Nozzle Tip').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Injection Piston' && (
                    <Image
                        image={InjectionPistonImg}
                        x={stageSize.width * 0.516}
                        y={stageSize.height * 0.327}
                        width={stageSize.width * 0.126}
                        height={stageSize.height * 0.2}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Injection%20Piston/reportview`,{ state: navigationState[('Injection Piston').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Radial Motor' && (
                    <Image
                        image={RadialMotorImg}
                        x={stageSize.width * 0.6776}
                        y={stageSize.height * 0.42}
                        width={stageSize.width * 0.081}
                        height={stageSize.height * 0.085}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Radial%20Motor/reportview`,{ state: navigationState[('Radial Motor').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Injection Cylinder' && (
                    <Image
                        image={InjectionCylinderImg}
                        x={stageSize.width * 0.601}
                        y={stageSize.height * 0.41}
                        width={stageSize.width * 0.14}
                        height={stageSize.height * 0.095}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/Injection%20Cylinder/reportview`,{ state: navigationState[('Injection Cylinder').toLowerCase()] })}
                    />
                )}
            </Layer>
        </Stage>
    )
}

export default InjectionUnitCanvas;
